<template>
<div>
    <!-- Help content -->
    <div class="preview-img-div cta" :class="`${category.toLowerCase()}`">
        <img src="@/assets/images/Clinician-test.png" loading="lazy" class="preview-image">
        <img src="@/assets/images/icon_-RX-black.svg" loading="lazy" alt="" class="image-403">
    </div>
    <div class="preview-details-div">
        <div class="preview-header-div">
            <div class="product-name-div">
                <div class="text-block-778">Not Sure?</div>
                <div class="text-block-779">We're here to help!</div>
            </div>
            <div class="preview-price-div">
                <div class="preview-price">
                    <div class="dollar hide">$</div>
                    <div class="product-amount hide">?</div>
                </div>
                <div class="daily-price hide">Help box</div>
            </div>
        </div>
        <div class="text-block-780">Connect with our Care Clinicians for help with your prescription</div>
        <div class="preview-button-div">
            <a href="#" class="preview-cta-button w-inline-block">
                <img src="@/assets/images/icon_SMS.svg" loading="lazy" alt="" class="image-404">
                <div class="text-block-801">Get Personalized Advice</div>
            </a>
        </div>
    </div>
</div>
</template>

<script>

export default {
    name: 'ProductCard',

    props: ["category"],

    data() {
        return {
            
        };
    },

    computed: {
    },

    methods: {
    },

    mounted() {
    },

    beforeDestroy() {
    }
};
</script>

<style scoped>
@media (min-width: 769px) {
    .add-margin{
        margin-top: 15px;
        position: relative;
    }
}
@media screen and (max-width: 479px) {
    .preview-button-div {
        align-items: center;
        justify-content: center;
    }
}
</style>
